// Keep these in sync with backend kerala_speaks.py constants.

export const AGE_GROUPS = [
  { id: "under-18", key: "age_under_18" },
  { id: "18-24", key: "age_18_24" },
  { id: "25-34", key: "age_25_34" },
  { id: "35-44", key: "age_35_44" },
  { id: "45-54", key: "age_45_54" },
  { id: "55-64", key: "age_55_64" },
  { id: "65-plus", key: "age_65_plus" },
];

export const OCCUPATIONS = [
  { id: "student", key: "occupation_student" },
  { id: "working", key: "occupation_working" },
  { id: "business", key: "occupation_business" },
  { id: "homemaker", key: "occupation_homemaker" },
  { id: "retired", key: "occupation_retired" },
  { id: "other", key: "occupation_other" },
];

export const GENDERS = [
  { id: "female", key: "gender_female" },
  { id: "male", key: "gender_male" },
  { id: "non-binary", key: "gender_non_binary" },
  { id: "prefer-not-to-say", key: "gender_prefer_not" },
];

export const DISTRICTS = [
  { id: "alappuzha", key: "district_alappuzha" },
  { id: "ernakulam", key: "district_ernakulam" },
  { id: "idukki", key: "district_idukki" },
  { id: "kannur", key: "district_kannur" },
  { id: "kasaragod", key: "district_kasaragod" },
  { id: "kollam", key: "district_kollam" },
  { id: "kottayam", key: "district_kottayam" },
  { id: "kozhikode", key: "district_kozhikode" },
  { id: "malappuram", key: "district_malappuram" },
  { id: "palakkad", key: "district_palakkad" },
  { id: "pathanamthitta", key: "district_pathanamthitta" },
  { id: "thiruvananthapuram", key: "district_thiruvananthapuram" },
  { id: "thrissur", key: "district_thrissur" },
  { id: "wayanad", key: "district_wayanad" },
  { id: "outside-kerala", key: "district_outside_kerala" },
];
